import { useMemo } from "react";

import { useFontFamilies } from "./useFontFamilies";
import { useUsedFontFamilies } from "./useUsedFontFamilies";
import { useTextZoneDashboard } from "./useTextZoneDashboard";

/** Return the font families that are supported for this product,
 * this is a combination of the basic font family list,
 * and the fonts used in this product/design. */
export function useSupportedFontFamilies(zone: eXpress.core.IZone | undefined) {
	// In case of an error, we use available fonts from the definition/configuration.
	const { data: fontFamilies = [] } = useFontFamilies();

	const usedFontFamilies = useUsedFontFamilies({
		fromConfiguration: true,
		fromDefinition: true,
		includeDefaultFont: true,
	});
	const dashboard = useTextZoneDashboard();

	return useMemo(
		() =>
			dashboard.canSetFontFamily(zone)
				? // Add fonts not in server list at the begin of the list
				  usedFontFamilies
						// Exclude fonts that already exist in the font family list from the used fonts
						.filter((ff) => !fontFamilies.includes(ff))
						// Sort so order doesn't change is a zone is removed
						.sort()
						// Add allowed fonts from server
						.concat(fontFamilies)
				: [],
		[dashboard, fontFamilies, usedFontFamilies, zone],
	);
}
